import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import { DashboardWrapper } from "../components/layout/DashboardWrapper";

import { PermissionsPage } from "../features/access/pages/PermissionsPage";
import { RolesPage } from "../features/access/pages/RolesPage";
import { UsersPage } from "../features/access/pages/UsersPage";

import { ActivityPage } from "../features/activity/pages/ActivityPage";

import { LoginPage } from "../features/auth/pages/LoginPage";

import { BrandsPage } from "../features/brands/pages/BrandsPage";

import { PosClientsPage } from "../features/clients/pages/PosClientsPage";

import { CurrenciesPage } from "../features/currencies/pages/CurrenciesPage";

import { DashboardPage } from "../features/dashboard/pages/DashboardPage";

import { RulesPage } from "../features/rules/pages/RulesPage";

import { SettingsPage } from "../features/settings/pages/SettingsPage";

import { ShopWifiPackageRulesPage } from "../features/shop-wifi-rules/pages/ShopWifiPackageRulesPage";

import { ShopsPage } from "../features/shops/pages/ShopsPage";

import FirewallConfigurationPage from "../features/system/firewallConfiguration/pages/FirewallConfigurationPage";

import { TrafficAnalyticsPage } from "../features/traffic-analytics/pages/TrafficAnalyticsPage";

import { VouchersPage } from "../features/vouchers/pages/VouchersPage";

import { WifiPackagesPage } from "../features/wifi-packages/pages/WifiPackagesPage";

import {
  ProtectedRoute,
  PublicOnlyRoute,
} from "./ProtectedRoute";

export function AppRouter() {
  return (
    <Routes>
      {/* Public routes */}

      <Route
        element={
          <PublicOnlyRoute />
        }
      >
        <Route
          path="/login"
          element={
            <LoginPage />
          }
        />
      </Route>

      {/* Protected routes */}

      <Route
        element={
          <ProtectedRoute />
        }
      >
        <Route
          element={
            <DashboardWrapper />
          }
        >
          {/* Dashboard */}

          <Route
            index
            element={
              <DashboardPage />
            }
          />

          {/* Operations */}

          <Route
            path="activity"
            element={
              <ActivityPage />
            }
          />

          <Route
            path="traffic-analytics"
            element={
              <TrafficAnalyticsPage />
            }
          />

          <Route
            path="vouchers"
            element={
              <VouchersPage />
            }
          />

          <Route
            path="rules"
            element={
              <RulesPage />
            }
          />

          <Route
            path="shops"
            element={
              <ShopsPage />
            }
          />

          <Route
            path="brands"
            element={
              <BrandsPage />
            }
          />

          <Route
            path="/admin/shops/:shopId/wifi-rules"
            element={
              <ShopWifiPackageRulesPage />
            }
          />

          <Route
            path="currencies"
            element={
              <CurrenciesPage />
            }
          />

          <Route
            path="wifi-packages"
            element={
              <WifiPackagesPage />
            }
          />

          <Route
            path="pos-clients"
            element={
              <PosClientsPage />
            }
          />

          {/* System */}

          <Route
            path="system/firewall-configuration"
            element={
              <FirewallConfigurationPage />
            }
          />

          {/* Access */}

          <Route
            path="access"
            element={
              <Navigate
                to="/access/users"
                replace
              />
            }
          />

          <Route
            path="access/users"
            element={
              <UsersPage />
            }
          />

          <Route
            path="access/roles"
            element={
              <RolesPage />
            }
          />

          <Route
            path="access/permissions"
            element={
              <PermissionsPage />
            }
          />

          <Route
            path="settings"
            element={
              <SettingsPage />
            }
          />

          {/* Legacy redirects */}

          <Route
            path="issue-voucher"
            element={
              <Navigate
                to="/activity"
                replace
              />
            }
          />

          <Route
            path="transactions"
            element={
              <Navigate
                to="/activity"
                replace
              />
            }
          />

          <Route
            path="reward-rules"
            element={
              <Navigate
                to="/rules"
                replace
              />
            }
          />

          <Route
            path="outlets"
            element={
              <Navigate
                to="/shops"
                replace
              />
            }
          />

          <Route
            path="api-clients"
            element={
              <Navigate
                to="/pos-clients"
                replace
              />
            }
          />

          <Route
            path="users"
            element={
              <Navigate
                to="/access/users"
                replace
              />
            }
          />
        </Route>
      </Route>

      {/* Unknown routes */}

      <Route
        path="*"
        element={
          <Navigate
            to="/"
            replace
          />
        }
      />
    </Routes>
  );
}